export const SCRATCH_WIDTH = 600
export const SCRATCH_HEIGHT = 360
export const SCRATCH_RADIUS = 32
export type ScratchPoint = { x: number; y: number }

/** A small coverage grid counts each area once; no expensive pixel readback on touch. */
export function scratchCoverage(
  covered: Set<number>,
  from: ScratchPoint,
  to: ScratchPoint
): number {
  const columns = 40
  const rows = 24
  const dx = to.x - from.x
  const dy = to.y - from.y
  const lengthSquared = dx * dx + dy * dy
  for (let row = 0; row < rows; row++) {
    for (let column = 0; column < columns; column++) {
      const key = row * columns + column
      if (covered.has(key)) continue
      const x = ((column + 0.5) / columns) * SCRATCH_WIDTH
      const y = ((row + 0.5) / rows) * SCRATCH_HEIGHT
      const t = lengthSquared
        ? Math.max(
            0,
            Math.min(1, ((x - from.x) * dx + (y - from.y) * dy) / lengthSquared)
          )
        : 0
      if ((x - from.x - t * dx) ** 2 + (y - from.y - t * dy) ** 2 <= SCRATCH_RADIUS ** 2)
        covered.add(key)
    }
  }
  return covered.size / (columns * rows)
}

export function paintScratchCover(context: CanvasRenderingContext2D) {
  const gradient = context.createLinearGradient(0, 0, SCRATCH_WIDTH, SCRATCH_HEIGHT)
  gradient.addColorStop(0, '#a8bf93')
  gradient.addColorStop(0.35, '#e8f3d9')
  gradient.addColorStop(0.65, '#b9cca0')
  gradient.addColorStop(1, '#f1f6de')
  context.fillStyle = gradient
  context.fillRect(0, 0, SCRATCH_WIDTH, SCRATCH_HEIGHT)
  for (let x = 12; x < SCRATCH_WIDTH; x += 20) {
    for (let y = 12; y < SCRATCH_HEIGHT; y += 20) {
      context.fillStyle = '#36553818'
      context.fillRect(x, y, 2, 2)
    }
  }
  context.strokeStyle = '#47613e55'
  context.lineWidth = 2
  context.setLineDash([7, 8])
  context.strokeRect(20, 20, SCRATCH_WIDTH - 40, SCRATCH_HEIGHT - 40)
  context.setLineDash([])
  context.textAlign = 'center'
  context.fillStyle = '#314930'
  context.font = '48px sans-serif'
  context.fillText('✦', 300, 113)
  context.font = '900 36px sans-serif'
  context.fillText('RASPE AQUI', 300, 183)
  context.font = '24px sans-serif'
  context.fillText('Uma surpresa só sua.', 300, 225)
  context.font = '24px sans-serif'
  context.fillText('Arraste o dedo ou o mouse', 300, 277)
}
